import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { tap } from 'rxjs/operators';
import { FeatureFlipService } from '../services/feature-flip.service';

export const formGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const featureFlipService = inject(FeatureFlipService);
  const isEnabled = featureFlipService.formsEnabled$;
  const router = inject(Router);

  return isEnabled.pipe(
    tap(enabled => {
      if (!enabled) {
        router.navigate(['']);
      }
    })
  )
}
